import axios from 'axios';

axios.defaults.withCredentials = true;

let httpApi = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
        'Accept': 'application/json',
        // 'Referer': process.env.VUE_APP_URL
    }
});

export default httpApi;